var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getActiveDiagram } from '../theme';
import { createDiagramGroup, readCanvasSize, } from '../helpers';
import { createLabeledBox, } from '../primitives';
import { mindMapLayout } from '../layouts';
import { wireMindMapConnectors } from '../connectors';
/** Create mind map — Mermaid-style left/right tree with smooth horizontal links */
export function createMindMap(app, center, branches, options) {
    if (options === void 0) { options = {}; }
    var group = createDiagramGroup(app, 'mindMap', __assign(__assign({}, options), { center: center, branches: branches }), { name: 'mindMap' });
    var canvas = readCanvasSize(options);
    var centerNode = createLabeledBox(app, center, 140, 52, {
        fill: getActiveDiagram().mindCenter.fill,
        stroke: getActiveDiagram().mindCenter.stroke,
        cornerRadius: 26,
        strokeWidth: 2,
        shadow: null,
        sheen: false,
    }, { fontSize: getActiveDiagram().fontSize.lg, fontWeight: '700' });
    centerNode.metadata.diagramId = 'center';
    centerNode.metadata.diagramCardWidth = 140;
    centerNode.metadata.diagramCardHeight = 52;
    group.add(centerNode);
    branches.forEach(function (branch, bi) {
        var palette = getActiveDiagram().mindBranchPalette[bi % getActiveDiagram().mindBranchPalette.length];
        var branchNode = createLabeledBox(app, branch.label, 112, 40, {
            fill: palette.fill,
            stroke: palette.stroke,
            cornerRadius: 20,
            strokeWidth: 1.75,
            shadow: null,
            sheen: false,
        }, { fontSize: getActiveDiagram().fontSize.base, fontWeight: '600' });
        branchNode.metadata = {
            diagramId: "branch_".concat(bi),
            mindBranchColor: palette.stroke,
            mindBranchGlow: palette.glow,
            diagramCardWidth: 112,
            diagramCardHeight: 40,
        };
        group.add(branchNode);
        if (branch.children) {
            branch.children.forEach(function (child, ci) {
                var childNode = createLabeledBox(app, child, 96, 30, {
                    fill: getActiveDiagram().mindLeaf.fill,
                    stroke: palette.stroke,
                    cornerRadius: 15,
                    strokeWidth: 1.5,
                    shadow: null,
                    sheen: false,
                }, { fontSize: getActiveDiagram().fontSize.sm, fontWeight: '500' });
                childNode.metadata.diagramId = "branch_".concat(bi, "_leaf_").concat(ci);
                childNode.metadata.diagramCardWidth = 96;
                childNode.metadata.diagramCardHeight = 30;
                branchNode.add(childNode);
            });
        }
    });
    mindMapLayout(group, canvas.width, canvas.height);
    wireMindMapConnectors(app, group);
    return group;
}
